import React from "react";

export default function AprilFoolDay5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-apr51{fill:#7f00e2}.cls-apr52{fill:#6c2f9b}.cls-apr53{fill:#f79b16}.cls-apr54{fill:#e08205}.cls-apr55{fill:#9f15f9}"
            }
          </style>
        </defs>
        <circle cx={1656.34} cy={1069.28} r={16.95} className="cls-apr53" />
        <path
          d="m992.67 1685.99 366.76 95.25c11.88-167.65 23.77-335.3 35.65-502.96l-402.41-87.37v495.07Z"
          className="cls-apr51"
        />
        <path
          d="M1359.43 1781.24c-122.25 26.54-244.51 53.08-366.76 79.63V1365.8l402.41-87.37c-11.88 167.6-23.77 335.21-35.65 502.81Z"
          className="cls-apr55"
        />
        <path
          d="m1336.26 1707.64-272.41 59.14v-335.12l272.41-59.15v335.13z"
          className="cls-apr53"
        />
        <path
          d="m1306.2 1673.16-204.34 44.36v-251.38l204.34-44.37v251.39zM992.82 1685.84l-363.68 96.18-39.03-503.58 402.34-87.66.37 495.07Z"
          className="cls-apr55"
        />
        <path
          d="M628.92 1781.89c121.25 26.32 242.5 52.65 363.75 78.97v-495.07l-402.41-87.37c12.89 167.82 25.77 335.64 38.66 503.46Z"
          className="cls-apr51"
        />
        <path
          d="m647.63 1707.64 272.4 59.14v-335.12l-272.4-59.15v335.13z"
          className="cls-apr54"
        />
        <path
          d="m677.69 1673.16 204.34 44.36v-251.38l-204.34-44.37v251.39z"
          className="cls-apr51"
        />
        <path
          d="M899.14 1358.58c-3.78-36.38 2.35-68.68 18.22-96.01 0 0 .01-.02.02-.03-4.17-3.99-8.18-8.12-11.98-12.39-15.5-17.39-26.93-35.87-33.96-54.92-7.75-20.98-9.72-41.57-5.87-61.2 1.02-5.18 2.46-10.28 4.3-15.29-.51-.35-1.01-.69-1.5-1.04-21.58-15.2-34.89-34.34-39.56-56.91-4.86-23.48.02-49.49 14.12-75.21 12.95-23.62 33.02-46.03 58.06-64.82l12.6 16.8c-46.72 35.05-71.92 81.75-64.22 118.97 3.5 16.89 13.45 31.31 29.74 43.16 18.91-31.17 54.32-57.15 100.56-72.64 49.23-16.49 113.26-20.27 145.33 8.47 21.26 19.04 29.47 53.27 18.71 77.92-19.23 44.04-93.3 44.12-117.64 44.15-4.78 0-48.46-.29-93.35-11.98-16.63-4.33-31.47-9.73-44.36-16.11a78.23 78.23 0 0 0-2.2 8.58c-6.03 30.7 6.69 66.46 34.9 98.1 2.7 3.03 5.51 5.99 8.41 8.86 13.6-16.8 31.6-31.38 52.97-42.79 25.49-13.61 54.5-22.27 83.9-25.02 45.05-4.23 83.37 6.46 102.51 28.58 14.11 16.31 19.44 39.16 13.59 58.23-7.05 22.96-30.52 41.01-66.09 50.82-30.79 8.49-67.38 9.65-97.87 3.1-29.22-6.27-59.2-21.07-84.91-41.35-12.14 22.69-16.7 49.51-13.55 79.8l-20.89 2.17Zm46.01-99.57c23.49 18.9 51.01 32.67 77.74 38.41 53.77 11.55 128.69-4.44 139.47-39.56 3.66-11.93-.2-27.69-9.4-38.32-14.49-16.75-46.93-24.95-84.66-21.41-39.1 3.67-92.2 21.85-123.15 60.88Zm-48.08-148.55c11.62 5.79 25.28 10.73 40.95 14.81 42.34 11.03 83.45 11.3 88.03 11.3 10.76-.01 33.14-.04 54.16-4.55 23.76-5.1 38.65-14.18 44.25-27.01 7.11-16.29.94-40.96-13.48-53.87-21.63-19.38-74.06-21.15-124.65-4.2-41.52 13.91-73.01 36.65-89.27 63.51Z"
          className="cls-apr53"
        />
        <ellipse
          cx={772.47}
          cy={1569.65}
          className="cls-apr54"
          rx={55.93}
          ry={68.83}
          transform="rotate(-7.18 771.988 1568.753)"
        />
        <path
          d="M590.27 1278.43c-6.45 19.79-19.16 50.39-44.66 81.11-20.7 24.94-42.56 41.21-58.59 51.26a4267.209 4267.209 0 0 0 309.75 74.13c38.49 7.7 76.45 14.75 113.84 21.18 13.75-11.23 31.64-28.43 47.65-52.95 22.32-34.18 30.83-66.98 34.42-87.37-134.14-29.12-268.27-58.24-402.41-87.37ZM1395.08 1278.43s30.89 80.31 57.36 99.72c-21.62 1.18-43.24 2.35-64.86 3.53l7.5-103.25Z"
          className="cls-apr52"
        />
        <ellipse
          cx={1211.42}
          cy={1569.65}
          className="cls-apr53"
          rx={68.83}
          ry={55.93}
          transform="rotate(-82.82 1211.528 1569.671)"
        />
        <path
          d="M1355.42 1151.4c173.72-48.52 307.8-21.56 334.43 42.87 4.83 11.68 14.84 45.67-22.89 107.78-19.57-24.01-46.75-51.91-83.37-77.28-89.73-62.16-182.37-71.9-228.17-73.38Z"
          className="cls-apr51"
        />
        <path
          d="M1333.34 1106.59c59.03-108.2 136.14-161 180.38-143.34 8.02 3.2 29.44 14.5 41.87 62.58-21.09-1.86-47.7-1.84-77.58 4-73.21 14.31-122.13 55.04-144.68 76.76ZM566.71 1145.7c-83.6-118.46-172.57-164.2-212.66-131.41-7.27 5.94-26.05 25.2-27.47 87.5 20.61-7.56 47.16-14.18 78.29-14.45 76.29-.66 134.39 37.25 161.84 58.37Z"
          className="cls-apr53"
        />
        <path
          d="M536.23 1172.29c-79.32-20.49-134.37-7.68-139.66 21.1-.96 5.22-2.01 20.38 20.14 47.74 6.12-10.79 15.14-23.35 28.45-34.84 32.63-28.17 71.52-33.06 91.07-34ZM580.65 1113.79c33.73-74.66 30.51-131.09 3.05-141.21-4.98-1.84-19.74-5.46-50.48 11.7 9.59 7.87 20.42 18.9 29.47 33.98 22.18 36.96 20.37 76.12 17.96 95.54ZM1303.89 1069.28c-15.36-100.97 5.22-162.14 39.05-158.93 6.13.58 23.77 4.33 53.08 39.68-13.11 3.71-28.58 10.27-43.27 22.3-35.99 29.46-45.73 74.04-48.86 96.95Z"
          className="cls-apr51"
        />
        <path
          d="M1103.54 939.66H660.51c-85.99 0-155.95-69.96-155.95-155.95V340.68c0-85.99 69.96-155.95 155.95-155.95h443.03c85.99 0 155.95 69.96 155.95 155.95v443.03c0 85.99-69.96 155.95-155.95 155.95ZM660.51 205.73c-74.41 0-134.95 60.54-134.95 134.95v443.03c0 74.41 60.54 134.95 134.95 134.95h443.03c74.41 0 134.95-60.54 134.95-134.95V340.68c0-74.41-60.54-134.95-134.95-134.95H660.51Z"
          className="cls-apr53"
        />
        <circle cx={702.47} cy={1017.59} r={24.78} className="cls-apr51" />
        <circle cx={1264.85} cy={1162.26} r={24.78} className="cls-apr53" />
        <circle cx={1217.01} cy={1000.64} r={16.95} className="cls-apr51" />
        <circle cx={515.06} cy={1274.65} r={16.95} className="cls-apr51" />
        <circle cx={409.36} cy={878.81} r={16.95} className="cls-apr53" />
        <circle cx={1538.63} cy={1274.65} r={16.95} className="cls-apr51" />
        <circle cx={1508.14} cy={830.39} r={16.95} className="cls-apr51" />
        <circle cx={677.69} cy={1162.26} r={16.95} className="cls-apr53" />
        <circle cx={283.91} cy={1003.97} r={16.95} className="cls-apr51" />
        {children}
      </g>
    </svg>
  );
}
